var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "0 10px" } },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isContentLoading,
              expression: "isContentLoading",
            },
          ],
          staticStyle: { "min-height": "1000px" },
        },
        [
          _c("insure-info-detail-custom", {
            ref: "refInsureInfoDetail",
            attrs: {
              "insure-type": _vm.insureType,
              "is-loading": _vm.isLoading,
              "pub-detail": _vm.tempDetail,
              "pub-info": _vm.tempPubInfo,
            },
            on: {
              onDetailDeal: _vm.onDetailDeal,
              onDetailSearch: _vm.onDetailSearch,
            },
          }),
        ],
        1
      ),
      _c("insure-notices", {
        ref: "refShowNotices",
        on: { onToInsure: _vm.onAgreeInsure },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }